/**
 * Включён ли у посетителя VPN — ответ сервера по адресам, под которыми браузер виден снаружи.
 *
 * `POST /v1/network/vpn-check` работает без входа: экран «У вас включён VPN» стоит и перед экраном
 * входа. Сервер смотрит и на адрес самого запроса — так видно VPN, пускающий через себя всё, — и
 * на адреса из `publicAddresses.ts` — так видно VPN, который пускает российские сайты мимо себя.
 */
import { apiRequest } from '@/shared/api/client';
import { gatherPublicAddresses } from './publicAddresses';

export interface VpnVerdict {
  vpn: boolean;
  /** Текст под заголовком экрана. Пишет сервер — одна фраза на все клиенты. */
  message: string | null;
}

/** Запасной текст, если сервер ответил «VPN», но без слов. Слово в слово как на сервере. */
export const VPN_BLOCKED_TEXT =
  'Пользоваться приложением с включённым VPN нельзя. Отключите VPN, чтобы продолжить.';

/**
 * Одна проверка. `null` — «не знаем» (нет связи, сервер не ответил): решение остаётся прежним.
 * Ошибкой это не считается — закрыть приложение человеку без VPN из-за нашей же поломки хуже,
 * чем пропустить.
 */
export async function checkVpn(
  gather: () => Promise<string[]> = gatherPublicAddresses,
): Promise<VpnVerdict | null> {
  const ips = await gather();
  try {
    return await apiRequest<VpnVerdict>('/v1/network/vpn-check', {
      method: 'POST',
      body: { ips },
    });
  } catch {
    return null;
  }
}
